import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../CommonComponents/BreadCrumb/BreadCrumb";
import Button from "../../../Elements/Button";
import CustomTable from "../../../CommonComponents/Table/CustomTable";
import { networkService } from "../../../config/axios";
import AdminPagination from "../../../CommonComponents/Pagination/AdminPagination";
import DataPerPage from "../../../CommonComponents/Pagination/DataPerPage";
import SearchComponent from "../../../CommonComponents/SearchComponent/SearchComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import "../admin.css";

const AdminCustomisationLogPage = (props) => {
    const [customizationLogs, setCustomizationlLogs] = useState([])
    const [currentPageData, setCurrentPageData] = useState([]);
    const [dataPerPage, setDataPerPage] = useState(10);
    const totalData = customizationLogs?.length;

    const handlePageChange = (pageNumber) => {
        const indexOfLastData = pageNumber * dataPerPage;
        const indexOfFirstData = indexOfLastData - dataPerPage;
        setCurrentPageData(customizationLogs?.slice(indexOfFirstData, indexOfLastData));
    };

    useEffect(() => {
        const fetchLogs = async () => {
            const response = await networkService("admin/customization_log.json", "GET");
            setCustomizationlLogs([...response.data?.customizations_log]);
        };
        fetchLogs();
    }, []);

    useEffect(() => {
        handlePageChange(1);
    }, [customizationLogs, dataPerPage])

    const columns = React.useMemo(() => {
        return [
            {
                Header: 'User Name',
                accessor: 'user_name',
            },
            {
                Header: 'Message',
                accessor: 'message',
            },
            {
                Header: 'Approved',
                accessor: 'approved',
                Cell: ({ row }) => (
                    <>
                        {row?.original?.approved ?
                            <Button
                                classList={'success'}
                                text={'Approved'}
                            /> :
                            <Button
                                classList={'alert'}
                                text={'Rejected'}
                            />
                        }
                    </>
                )
            },
        ];
    }, [currentPageData]);

    return (
        <>
            <div className="admin-module">
                <div className="admin-customization-page admin-content">
                    <Breadcrumb string="Admin / Customization Logs" />

                    <div className="container admin-customization-container">
                        <div className=" mb-4 show-select1 d-flex admin-customization-header">
                            <div className="admin-customization-controls admin-customization-search-group">
                                {totalData > dataPerPage && <DataPerPage dataPerPage={dataPerPage} setDataPerPage={setDataPerPage} />}
                                <div className="admin-customization-search-input-wrap">
                                    <SearchComponent
                                        data={customizationLogs}
                                        setCurrentPageData={setCurrentPageData}
                                        placeholder="Search here"
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="admin-customization-search-btn"
                                    aria-label="Search"
                                >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                            </div>
                        </div>

                        <div className="top-parent admin-customization-table-wrapper">
                            <CustomTable data={currentPageData} columnData={columns} showFilters={false} />
                        </div>

                        {totalData > dataPerPage && (
                            <AdminPagination
                                dataPerPage={dataPerPage}
                                totalData={totalData}
                                onPageChange={handlePageChange}
                                showRange={true}
                                previousLabel="‹ Previous"
                                nextLabel="Next ›"
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
export default AdminCustomisationLogPage;
